// extracted by mini-css-extract-plugin
module.exports = {"list":"Alternative_list__SSeZQ","item":"Alternative_item__K43G5"};